import React, { useEffect, useState } from "react";
import myPhoto2 from "../../assets/myPhoto3.png";
import Button from "../UI/Button";
import "./style.css";

import TextTransition, { presets } from "react-text-transition";
import { db } from "../../firebase";
import axios from "axios";
import "../UI/style.css";
import EmailModal from "../EmailModal/EmailModal";

const TEXTS = ["Web ", " Mobile "];

const Header = (props) => {
  const [index, setIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);

  const downloadResume = async () => {
    try {
      const res = await axios.get("https://geolocation-db.com/json/");

      var browser = (function () {
        var test = function (regexp) {
          return regexp.test(window.navigator.userAgent);
        };
        switch (true) {
          case test(/edg/i):
            return "Microsoft Edge";
          case test(/trident/i):
            return "Microsoft Internet Explorer";
          case test(/firefox|fxios/i):
            return "Mozilla Firefox";
          case test(/opr\//i):
            return "Opera";
          case test(/ucbrowser/i):
            return "UC Browser";
          case test(/samsungbrowser/i):
            return "Samsung Browser";
          case test(/chrome|chromium|crios/i):
            return "Google Chrome";
          case test(/safari/i):
            return "Apple Safari";
          default:
            return "Other";
        }
      })();

      var datetime =
        new Date().toLocaleString().slice(0, 9) +
        " " +
        new Date(new Date()).toString().split(" ")[4];

      await db
        .collection("ResumeDownloads")
        .doc(datetime + "  " + res.data.IPv4)
        .set({
          Ipv4: res.data.IPv4,
          city: res.data.city,
          longititude: res.data.longitude,
          latitude: res.data.latitude,
          state: res.data.state,
          browser,
        });
    } catch (error) {}
  };

  useEffect(() => {
    const intervalId = setInterval(
      () => setIndex((index) => index + 1),
      3000 // every 3 seconds
    );
    return () => clearTimeout(intervalId);
  }, []);

  return (
    <div className="container" style={{ paddingTop: "70px" }}>
      <div className="flexRow flexCol justify-sb align-center">
        <div data-aos="fade-right" className="headerMarg">
          {/*  <Tilt options={{ max: 25 }}>
            <div className="Tilt-inner"> */}
          <p className=" bold-500 textColor ls-1 mtb-10 scaleUp">
            <span>Hi there! 👋🏻</span>
            <br />
            <br />
            <span
              className={
                navigator.userAgent.match(/samsung/i)
                  ? "upperCase primaryColor"
                  : "upperCase"
              }
            >
              I am Rashid,
            </span>
          </p>

          <div style={{ display: "flex", margin: "0px" }}>
            <h1
              className={
                navigator.userAgent.match(/samsung/i)
                  ? "primaryColor scaleIn"
                  : "textColor scaleIn"
              }
            >
              I develop&nbsp;
              <TextTransition
                text={TEXTS[index % TEXTS.length]}
                springConfig={presets.slow}
                inline={true}
              />
              &nbsp;Apps
              {/*  <Typewriter
                options={{
                  strings: ["Web Developer", " Mobile App Developer"],
                  autoStart: true,
                  loop: true,
                  cursorClassName: "cursorStyle",
                }}
              /> */}
            </h1>
          </div>
          {/*  <p className="font-12 grey mtb-10">Web/Mobile</p> */}
          <div className="flexRow" style={{ margin: "30px 0" }}>
            <div>
              <Button
                label="Hire Me"
                /*  onClick={(e) => {
                  e.preventDefault();
                  window.open("mailto:rashidrizvi998@gmail.com", "_self");
                }} */
                onClick={() => setShowModal(!showModal)}
                href="javascript:void(0)"
                /*  href={"mailto:rashidrizvi998@gmail.com"} */
              />
            </div>
            {showModal && (
              <EmailModal showModal={showModal} setShowModal={setShowModal} />
            )}

            <div className="mlr-10">
              <Button
                label="Download Resume"
                inverse={false}
                href={"https://rashid-ahamed.vercel.app/RashidAhamed.pdf"}
                onClick={downloadResume}
              />
              {/*  <Link
                  className="scaleIn"
                  style={{
                    boxSizing: "border-box",
                    padding: "10px 20px",
                    background: "transparent",
                    color: colors.primaryColor,
                    display: "inline-block",
                    borderRadius: "20px",
                    boxShadow: "none",
                    border: "1px solid",
                    borderColor: colors.primaryColor,
                    fontSize: 12,
                    letterSpacing: "1px",
                  }}
                    label=""
                  inverse={true}
                  href={
                    "https://drive.google.com/file/d/1GGl1i8KLzpJ9Pj4_YOHYo8KBMby00AU3/view?usp=sharing"
                  }
                  onClick={downloadResume}
                  to="/RashidAhamed.pdf"
                  target="_blank"
                  download
                >
                  Download Resume
                </Link> */}
            </div>
          </div>
          {/*   </div>
          </Tilt> */}
        </div>
        <div data-aos="fade-left">
          <div className="meRightImgContainer">
            <img src={myPhoto2} alt="" loading="eager" className="scaleIn" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
